import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Agents = () => {
  const stats = [
    { label: 'Active Agents', value: '8', change: '+2', changeType: 'positive' },
    { label: 'Tasks Completed', value: '847', change: '+156', changeType: 'positive' },
    { label: 'Efficiency', value: '94%', change: '+3%', changeType: 'positive' },
    { label: 'Cost Saved', value: '$12,400', change: '+$2,100', changeType: 'positive' },
  ];

  const agents = [
    { name: 'Content Writer', status: 'Active', tasks: 234, efficiency: '96%' },
    { name: 'Social Manager', status: 'Active', tasks: 189, efficiency: '94%' },
    { name: 'Email Composer', status: 'Active', tasks: 156, efficiency: '92%' },
    { name: 'Ad Optimizer', status: 'Active', tasks: 123, efficiency: '98%' },
    { name: 'Lead Qualifier', status: 'Active', tasks: 89, efficiency: '91%' },
    { name: 'Analytics Bot', status: 'Paused', tasks: 56, efficiency: '89%' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">AI Agents</h1>
        <p className="lm-page-subtitle">Manage your automated marketing agents</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Agent Status</h3>
          <Button variant="primary" size="sm" icon="plus">Deploy Agent</Button>
        </div>
        <div className="lm-grid">
          {agents.map((agent, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{agent.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: agent.status === 'Active' ? 'var(--success-soft)' : 'var(--warning-soft)',
                  color: agent.status === 'Active' ? 'var(--success)' : 'var(--warning)'
                }}>{agent.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>{agent.tasks} tasks • {agent.efficiency} efficiency</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Agents;
